<template>
  <div class="module_page page_content institution rich_html_asset" aria-label="Create Rich Html Asset Page Content">
    <div>
      <div class="row page-heading border-0">
        <div class="col-9 input module_heading" :class="{invalid: $v.model.title.$error}">
          <span class="float-left icon-asset"></span>
          <input
            type="text"
            id="title"
            class="module_title"
            @blur="$v.model.title.$touch()"
            placeholder="Type asset name*"
            v-model.trim="model.title" v-focus
            aria-label="type asset name">
        </div>
        <div class="col-3 submit btn-container text-right">
          <button class="btn-cancel" @click.stop="cancel" aria-label="close"><span class="icon-cross"></span></button>
          <button class="btn btn-primary" @click.stop="onSubmit(true)" :disabled="submitted || (model.title.length === 0)" aria-label="done">done</button>
          <button class="btn btn-primary" @click.stop="onSubmit(false)" :disabled="submitted || (model.title.length === 0)" aria-label="save">save</button>
        </div>
      </div>
      <div class="page-content pb-5" style="background: #f5f5f5;">
        <div class="row assessment-section">
          <div class="col-12">

              <div class="row assessment-right-section pl-0 mb-5">
                <div class="col-4 page_section_row">
                  <div class="heading">
                    <span for="folder" id="folderName">Folder</span>
                  </div>
                  <div class="folder-name ml-3">
                    <template v-if="isShowFolderDropDown">
                      <select id="folder" v-model="model.owningLibrary" aria-labelledby="folderName">
                        <option v-for="folder in folders" :value="{uuid: folder.uuid, displayName: folder.displayName}">{{ folder.displayName }}</option>
                      </select>
                    </template>
                    <template v-else>
                      <div>{{ entity.ancestorName }}</div>
                    </template>
                  </div>
                </div>

                <div class="col-8 page_section_row">
                  <div class="">
                    <div class="heading tag-heading">
                      <span class="ic-tag general mr-2"></span>
                      <span id="assetTags">Tags</span>
                      <span class="icon-pencil2 ml-2" style="cursor: pointer;" @click="showAddTagPopup($event)"></span>
                    </div>
                    <div class="value ml-3">
                      <div class="tag-box-list">
                        <template v-for="(values, key, i) in model.appliedTagMap" class="tags_container">
                          <span class="tag" v-for="(tag, j) in values">
                          <span class="tag_name instructional_tag ace_sec_txt">{{tag.name}}</span>
                          </span>
                        </template>
                      </div>
                    </div>
                    <template>
                      <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
                    </template>
                  </div>

                </div>

            </div>
          </div>

          <div class="col-12 assessment-left-section">
            <div class="page-section">
              <div class="page_section_row" v-if="entity.type !== 'RICH_HTML'" style="display:none;">
                <div class="heading border-0">
                  <span for="description" id="assetDescription">Description</span>
                </div>
                <div class="value ml-3">
                  <textarea rows="4" cols="50"
                    id="description"
                    placeholder="Type in the asset description..."
                    v-model="model.description"
                    aria-labelledby="assetDescription">
                  </textarea>
                </div>
              </div>
              <div class="page_section_row">
                <div class="heading border-0 mb-2">
                  <span v-if="isMarkdownEnabled">Markdown Content</span>
                  <span v-else>HTML Content</span>
                  <template v-if="uuid && isRichHtmlAssessment(model.htmlBody)">
                    <span> (non editable)</span>
                  </template>
                  <template v-if="!uuid">
                    <span class="float-right">
                      <span v-if="isMarkdownEnabled">Switch to HTML Editor</span>
                      <span v-else>Switch to Markdown Editor</span>
                      <span class="ml-2">
                        <switches v-model="isMarkdownEnabled" theme="default" color="blue" emit-on-mount="false"></switches>
                      </span>
                    </span>
                  </template>
                </div>
                <div class="value ml-3">
                  <template v-if="uuid">
                    <div class="html-view-section">
                      <template v-if="isRichHtmlAssessment(model.htmlBody)">
                        <div id="editor">
                          <rich-html-launch-assessment :resource-id="uuid" :html="model.htmlBody"></rich-html-launch-assessment>
                        </div>
                      </template>
                      <template v-else>
                        <template v-if="isMarkdownEnabled">
                          <div id="editor">
                            <textarea :value="model.markdownInput" @input="update" style="height:300px" rows="50" cols="50" placeholder="Input the markdown content here..."></textarea>
                            <template v-if="model.markdownInput">
                              <b-modal id="markdownHtml" size="lg" centered hide-footer>
                                <div slot="modal-header" class="header-section">
                                  <div class="popup-heading">HTML Preview</div>
                                  <div class="float-right">
                                    <button type="button" aria-label="Close" class="" @click="closeMarkdownHtml">x</button>
                                  </div>
                                </div>
                                <vue-markdown :source="model.markdownInput" @rendered="markdownToHtml"></vue-markdown>
                              </b-modal>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div class="fld_input">
                            <editor api-key="no-api-key"
                              v-model.trim="model.htmlBody"
                              :init="{
                                base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                                autoresize_min_height: 300,
                                menubar: false,
                                plugins: plugins,
                                toolbar: toolbar,
                                toolbar_drawer: 'sliding_group',
                                branding: false,
                                statusbar: false,
                                image_advtab: true,
                                file_picker_callback: filePickerCallback,
                                end_container_on_empty_block: true
                              }"
                              @onInit="(event, editor) => {handlerInit(event, editor)}"
                              id="htmlBodyEditorTextId">
                            </editor>
                          </div>
                        </template>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="isMarkdownEnabled">
                      <div id="editor">
                        <textarea :value="model.markdownInput" @input="update" style="height:300px" rows="50" cols="50" placeholder="Input the markdown content here..."></textarea>
                        <template v-if="model.markdownInput">
                          <b-modal id="markdownHtml" size="lg" centered hide-footer>
                            <div slot="modal-header" class="header-section">
                              <div class="popup-heading">HTML Preview</div>
                              <div class="float-right">
                                <button type="button" aria-label="Close" class="" @click="closeMarkdownHtml">x</button>
                              </div>
                            </div>
                            <vue-markdown :source="model.markdownInput" @rendered="markdownToHtml"></vue-markdown>
                          </b-modal>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <div class="fld_input">
                        <editor api-key="no-api-key"
                          v-model.trim="model.htmlBody"
                          :init="{
                            base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                            autoresize_min_height: 300,
                            menubar: false,
                            plugins: plugins,
                            toolbar: toolbar,
                            toolbar_drawer: 'sliding_group',
                            branding: false,
                            statusbar: false,
                            image_advtab: true,
                            file_picker_callback: filePickerCallback,
                            end_container_on_empty_block: true
                          }"
                          @onInit="(event, editor) => {handlerInit(event, editor)}"
                          id="htmlBodyEditorTextId">
                        </editor>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="asset-upload-popup">
      <b-modal ref="createSuccessModal" size="lg" :title="'1 asset created'" :header-bg-variant="'create-asset-success-modal'" ok-disabled cancel-diasbled hide-header-close hide-footer no-close-on-backdrop no-close-on-esc centered>
        <div class="create-asset-row">
          <span class="text-label">
          Click if you have finished creating
          </span>
          <span class="result-btn">
            <b-button @click="closeAndRedirect" class="btn" aria-label="ok"> ok </b-button>
          </span>
        </div>
        <div class="mt-1"></div>
        <div class="create-asset-row">
          <span class="text-label">
          Click if you want to create more
          </span>
          <span class="result-btn">
            <b-button @click="showCreate" class="btn continue" aria-label="continue creating asset"> continue creating html rich asset </b-button>
          </span>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div style="visibility: hidden;">
      <input name="hidden" type="file" id="upload" class="hidden" aria-label="select file" onchange="">
    </div>
    <div>
      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import DataLossPrompt from '../../common/components/DataLossPrompt'
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import Switches from 'vue-switches'
  import VueMarkdown from 'vue-markdown'
  import Editor from '@tinymce/tinymce-vue'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import {required, minLength} from 'vuelidate/lib/validators'
  import '../../../assets/module/less/create_entity.less'
  import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  var initialState = function () {
    return {
      model: {
        title: '',
        description: '',
        owningLibrary: {},
        htmlBody: '',
        markdownInput: '',
        appliedTagMap: {}
      },
      folders: [],
      submitted: false,
      isMarkdownEnabled: false,
      isShowFolderDropDown: true,
      taggingEntityData: {},
      isShowTagPopup: false,
      plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools table lists',
      toolbar: 'undo redo  bold italic underline bullist numlist outdent indent link unlink alignleft aligncenter alignright alignjustify media insertfile image table forecolor backcolor | searchreplace removeformat | fontselect fontsizeselect styleselect',
      nextPage: undefined,
      dirty: false,
      oldModel: {}
    }
  }

  export default {
    name: 'rich-html-asset-create',
    props: ['uuid'],
    components: {
      Editor,
      Switches,
      VueMarkdown,
      AddTagPopup,
      RichHtmlLaunchAssessment,
      DataLossPrompt
    },
    data () {
      return initialState()
    },
    validations: {
      model: {
        title: {
          required,
          minLength: minLength(1)
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.dirty) {
        this.nextPage = next
        this.$refs.dataLossAlert.showPrompt()
        next(false)
      } else {
        next()
      }
    },
    mounted () {
      this.populateLibrary()

      setTimeout(() => {
        $('.mce-notification-warning').hide()
      }, 2500)

    },
    watch: {
      uuid (value) {
        if (!value) {
          this.showCreate()
        } else {
          this.populateLibrary()
        }
        setTimeout(() => {
          $('.mce-notification-warning').hide()
        }, 2500)
      },
      model: {
        handler () {
          this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'loadLibrariesForUser',
        'createAsset',
        'loadEntityDetail'
      ]),
      populateLibrary () {
        const userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(userId).then(learningSpaces => {
          this.folders = []
          for (let i = 0; i < learningSpaces.length; i++) {
            const learningSpace = learningSpaces[i]
            const permission = learningSpace.acelist[0].permission
            if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
              this.folders.push(learningSpace)
              if (learningSpace.category === 'Institute_Public') {
                this.model.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
              }
            }
          }
          if (this.uuid) {
            this.loadAssetDetail()
          } else {
            if (this.folders.length > 0 && _.isEmpty(this.model.owningLibrary)) {
              this.model.owningLibrary = {uuid: this.folders[0].uuid, displayName: this.folders[0].displayName}
            }
          }
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        })
      },
      loadAssetDetail () {
        var entityDetailInfo = {
          'entityUuid': this.uuid,
          'entityType': 'LearningContent'
        }
        this.loadEntityDetail(entityDetailInfo).then(res => {
          this.model.title = res.title
          this.model.htmlBody = res.htmlBody
          this.model.description = res.description
          if (res.appliedTagMap) {
            this.model.appliedTagMap = res.appliedTagMap
          }
          var userObject = JSON.parse(localStorage.getItem('userobj'))
          var libraries = userObject.userPreferences.learningSpaces
          this.isShowFolderDropDown = ($.inArray(res.ancestor, libraries) !== -1)
          if (this.isShowFolderDropDown) {
            for (var i = 0; i < this.folders.length; i++) {
              const learningSpace = this.folders[i]
              if (res.owningLibraryId === learningSpace.uuid) {
                this.model.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
                break
              }
            }
          }
        })
      },
      addTag () {
        var tagLength = $.trim($('#tagGeneral').val()).length
        if ($(tagLength).length > 0) {
          const richHtmlTag = {name: this.tag, auto: false, category: 'general'}
          var isExist = _.find(this.tags, function (tag) {
            return (richHtmlTag.name === tag.name)
          })
          if (!isExist) {
            this.tags.push(richHtmlTag)
          }
        }
        this.tag = ''
      },
      deleteTag (tag) {
        const index = this.tags.indexOf(tag)
        this.tags.splice(index, 1)
      },
      showAddTagPopup (event) {
        this.isShowTagPopup = true
        this.taggingEntityData = {title: this.model.title, type: 'assets', appliedTagMap: this.model.appliedTagMap}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },
      cancel () {
        this.$router.go(-1)
      },
      onSubmit (isDone) {
        if (this.$v.model.title.$error) {
          return
        }
        this.dirty = false
        this.$refs.loadingModal.show()
        this.submitted = true
        // const appliedTagMap = {general: this.tags}
        const formData = {
          title: this.model.title,
          description: this.model.description,
          htmlBody: this.model.htmlBody,
          type: 'RICH_HTML',
          appliedTagMap: this.model.appliedTagMap,
          ancestor: this.model.owningLibrary.uuid,
          owningLibraryId: this.model.owningLibrary.uuid
        }
        if (this.uuid) {
          formData.uuid = this.uuid
        }
        this.createAsset(formData).then(res => {
          this.$refs.loadingModal.hide()
          if (this.uuid) {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'HTML Rich Asset "' + this.model.title + '" updated successfully.'
            })
            if (isDone) {
              if (this.nextPage) {
                this.$emit('resolveNext', this.nextPage)
              } else {
                return this.$router.push({ name: 'assetPreview', params: { uuid: this.uuid } })
              }
            } else {
              this.submitted = false
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'HTML Rich Asset "' + this.model.title + '" created and saved successfully.'
            })
            if (isDone) {
              if (this.nextPage) {
                this.$emit('resolveNext', this.nextPage)
              } else {
                this.$refs.createSuccessModal.show()
              }
            } else {
              this.submitted = false
            }
          }
        })
      },
      closeAndRedirect () {
        this.$refs.createSuccessModal.hide()
        return this.$router.push({ name: 'results' })
      },
      showCreate () {
        if (this.$refs.createSuccessModal) {
          this.$refs.createSuccessModal.hide()
        }
        Object.assign(this.$data, initialState())
        this.populateLibrary()
        this.$v.title.$reset()
        $('#title').focus()
        this.$data.oldModel = _.cloneDeep(this.$data.model)
      },
      closeMarkdownHtml () {
        this.$root.$emit('bv::hide::modal', 'markdownHtml')
      },
      update: _.debounce(function (e) {
        this.model.markdownInput = e.target.value
      }, 300),
      markdownToHtml: _.debounce(function (html) {
        this.model.htmlBody = html
        this.$root.$emit('bv::show::modal', 'markdownHtml')
      }, 300),
      filePickerCallback (callback, value, meta) {
        if (meta.filetype === 'image') {
          $('#upload').trigger('click')
          $('#upload').on('change', function () {
            var file = this.files[0]
            var reader = new FileReader()
            reader.onload = function (e) {
              callback(e.target.result, {
                alt: ''
              })
            }
            reader.readAsDataURL(file)
          })
        }
      },
      okLose () {
        this.$emit('resolveNext', this.nextPage)
      },
      saveAndContinue () {
        this.onSubmit(true)
      },
      handlerInit (ev, editor) {
        $('#htmlBodyEditorTextId_ifr').css({'width': '100%', 'height': '300px', 'border': '1px solid #ccc'})
      },
      isRichHtmlAssessment (htmlBody) {
        return (htmlBody.indexOf('<p><div class="assessment-container"') !== -1)
      }
    },
    computed: {
      ...mapState({
        'entity': state => state.course.entity
      })
    }
  }
</script>

<style scoped>
  .input {
    margin: 10px auto;
  }
  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .invalid label {
    color: red;
  }

  .invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }

  .icon_autotag {
    font-size:28px;
  }
  .right-panel {
    height: calc(100vh - 286px);
    overflow-y: auto;
    margin-left: 150px;
  }
  select.form-control:not([size]):not([multiple]) {
    height:auto;
  }
  textarea {
    padding: 7px 11px;
  }
  input {
    padding-left: 11px;
  }
  .module_heading .module_title {
    margin-left: 15px;
  }
  .create-asset-row {
    margin-bottom: 15px;
    width: 100%;
    float: left;
  }
  .text-label {
    float:left;
  }
  .result-btn {
    float:left;
    margin-left: 13px;
  }
  .continue {
    margin-left: 15px;
  }
  .ok {
    margin-left:10px;
  }
  html, body, #editor {
    margin: 0;
    font-family: 'Helvetica Neue', Arial, sans-serif;
  }
  code {
    color: #f66;
  }
</style>



// WEBPACK FOOTER //
// src/app/learningContent/components/RichHtmlAssetCreate.vue